import 'isomorphic-fetch';
import { Literature } from '../typings/general';

interface FetchLiteratureOptions {
  readonly faServicesUrl: string;
  readonly apiKey: string;
  readonly modelYear?: string;
  readonly modelCode?: string;
  readonly vin?: string;
}

function createLiteratureUrl(
  params: URLSearchParams,
  urlOrigin: string,
): string {
  return `${urlOrigin}/maintenance/literature?${params.toString()}`;
}

export async function fetchLiterature({
  faServicesUrl,
  apiKey,
  modelYear,
  modelCode,
  vin,
}: FetchLiteratureOptions): Promise<Literature> {
  const params = new URLSearchParams();
  
  params.set('brand', 'V');
  params.set('importerCode', '444');
  params.set('languageCode', 'en-US');

  if (vin) params.set('vin', vin);

  if (modelYear) params.set('modelYear', modelYear);

  if (modelCode) params.set('modelCode', modelCode);

  const response = await fetch(createLiteratureUrl(params, faServicesUrl), {
    headers: { 'x-api-key': apiKey },
  });

  const literature = await response.json();

  if (response.status >= 400) throw new Error(literature.message);

  return literature;
}
